import { FormSelectId, FormSelectIdProps } from '@nexelem/form-components';
import { useCustomTranslation } from '../../../hooks';
import { useCompetenceCategories } from '../../../queryHooks/useCompetenceCategories';

type FormContractorSelectProps = Omit<FormSelectIdProps, 'label' | 'options' | 'placeholder'>;

export const FormCompetenceCategorySelect = (props: FormContractorSelectProps) => {
  const { t, tWrapper } = useCustomTranslation('workers.modals.addCompetence');
  const { data, isLoading } = useCompetenceCategories();

  const options = isLoading
    ? []
    : data?.map((contractor) => {
        return { id: contractor.id, label: contractor.name };
      });

  return (
    <FormSelectId
      {...props}
      label={tWrapper('category')}
      loading={isLoading}
      options={options}
      placeholder={t('components.filters.searchOrSelect')}
    />
  );
};
